import { getDateRange } from '@modules/common/components/DateRangePicker/helpers';
import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { mapToTimePeriodUnit } from '@modules/common/utils';
import dayjs, { OpUnitType } from 'dayjs';
import { CompareQueryProperty } from '../store/types';

export const getDurationForCompareByPreviousTimePeriod = (
  queryDuration: DateTimeRange,
  compareByPreviousPeriod?: CompareQueryProperty,
): DateTimeRange | null => {
  if (!compareByPreviousPeriod?.previousPeriod) {
    return null;
  }

  const [from] = getDateRange(queryDuration);

  if (!from) {
    return null;
  }

  const { value, unit } = compareByPreviousPeriod.previousPeriod;

  const startAfter = from
    .tz()
    .subtract(value, unit)
    .startOf(mapToTimePeriodUnit(unit) as OpUnitType);

  const endBefore = dayjs().tz().subtract(value, unit).startOf('hour').tz();

  return {
    type: 'absolute',
    endBefore,
    startAfter,
  };
};
